export default __webpack_public_path__ + "static/media/playstore-s4.6eaa550c.webp";